import { Component, EventEmitter, Injector, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { MaterialService } from 'src/app/material/material.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';

import { CushioningDetailsFormComponent } from '../cushioning-details-form/cushioning-details-form.component';
import { CommonService } from 'src/app-core/services/common.service';
import { NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { CommonDataModel } from '../common-data-model';

const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
  while (el && el.parentElement) {
    if (hasClass(el.parentElement, className)) {
      return true;
    }
    el = el.parentElement;
  }
  return false;
};

@Component({
  selector: 'app-container-cushioning-list',
  templateUrl: './container-cushioning-list.component.html',
  styleUrls: ['./container-cushioning-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContainerCushioningListComponent extends AppComponentBase implements OnInit {
  @ViewChild('grid', { static: true }) public grid: GridComponent;
  @ViewChild('cushioningMaterialForm', { static: false }) cushioningMaterialForm: NgForm;
  @Output() emitEnableSaveButton: EventEmitter<any> = new EventEmitter();
  @Output() collapseEmit: EventEmitter<any> = new EventEmitter();
  @Output() emitReCalculatePackagingQuantity: EventEmitter<any> = new EventEmitter();
  @Input() isExpanded: any;
  @Input() readOnly: boolean;
  @Input() corporatePackgingAndId: any;
  @Input() set containerIdParam(containerId: number) {
    if (containerId) {
      this.containerId = containerId;
    }
  }

  commonDataModal = new CommonDataModel();
  categories: Array<any>;
  defaultMaterialsList: Array<any>;
  defaultMaterialsListFiltered: Array<any>;
  units: Array<any>;
  editedRowIndex: number;
  containerQuantity: any;
  InitialItems: Array<any>;
  gridItems: any = {
    data: [],
    total: 0
  };
  containerId: number;
  containerDimention = _.cloneDeep(this.commonDataModal.containerDimention);
  isDisabledForm = false;
  constructor(
    injector: Injector,
    public dialog: MatDialog,
    private materialService: MaterialService,
    private commonService: CommonService,
    private renderer: Renderer2
  ) {
    super(injector);
    this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'cushioningGrid')) {
          if (this.cushioningMaterialForm.valid) {
            this.grid.closeRow(this.editedRowIndex);
            this.editedRowIndex = null;
            this.emitEnableSaveButton.emit();
          }
        }
      });
  }

  ngOnInit() {
    this.getDefaultMaterials();
    this.getUnits();
  }

  openAccordian(open: string, state: boolean) {
    if (open) {
      this.isExpanded = state;
      this.collapseEmit.emit();
    }
  }

  closeAccordian(open: string, state: boolean) {
    if (close) {
      this.isExpanded = state;
      this.collapseEmit.emit();
    }
  }


  getDefaultMaterials(dataItem?: any, material?: any) {
    let queryParam = '&MaterialCategoryId=6';
    if(this.corporatePackgingAndId && this.corporatePackgingAndId.isCorporate){
      queryParam+='&CallFrom=999'
    }else if(this.corporatePackgingAndId && this.corporatePackgingAndId.id && this.corporatePackgingAndId.id > 0){
      queryParam+='&id='+ this.corporatePackgingAndId.id;
    }

    this.commonService.getCleatsList(queryParam).subscribe(response => {
      if (response.isSuccess) {
        this.defaultMaterialsList = response.data;
        this.defaultMaterialsListFiltered = _.cloneDeep(response.data);
      }
    });
  }

  getUnits(): void {
    this.materialService.getUnits().subscribe(response => {
      if (response.isSuccess) {
        this.units = response.data;
      }
    });
  }

  getNewMaterial(): any {
    const itemModel = Object.assign({}, this.commonDataModal.containerMaterialModel);
    itemModel.categoryId = 6;
    const defaultMaterial = this.defaultMaterialsList.find(item => item.materialCategoryId == 6);
    if (defaultMaterial) {
      itemModel.materialId = defaultMaterial.id;
    } else {
      itemModel.materialId = null;
    }
    itemModel.unitId = 1;
    itemModel.unit = 'Inches';
    itemModel.isChanged = true;
    itemModel.cushioningDetails = this.getcushioningDetails();
    this.onMaterialChange(itemModel.materialId, itemModel, false);
    this.emitEnableSaveButton.emit();
    itemModel.layerOrder = this.gridItems.data.length + 1;
    return itemModel;
  }

  // temporary data
  getcushioningDetails(): any {
    return [{
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 1,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    },
    {
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 2,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    },
    {
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 3,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    },
    {
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 4,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    },
    {
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 5,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    }, {
      spacingId: 0,
      packagingId: 0,
      packagingMaterialId: 0,
      materialId: 0,
      faceId: 6,
      isIncluded: true,
      length: 0,
      width: 0,
      quantity: 0,
      isActive: true
    }
    ];
  }

  onAddMaterial() {
    if (this.cushioningMaterialForm.valid) {
      this.gridItems.data.splice(0, 0, this.getNewMaterial());
      this.cushioningMaterialForm.form.markAsDirty();
      this.emitEnableSaveButton.emit();
    }
  }

  onRemoveMaterial(index: any) {
    this.gridItems.data.splice(index, 1);
    this.cushioningMaterialForm.form.markAsDirty();
    this.emitReCalculatePackagingQuantity.emit();
    this.gridItems.data.map((item, index) => {
      item.layerOrder = index + 1;
    });
  }

  onCellClickHandler({ sender, rowIndex }, grid: any) {
    if (!this.isDisabledForm) {
      grid.closeRow(this.editedRowIndex);
      this.editedRowIndex = rowIndex;
      sender.editRow(rowIndex);
    }
  }

  onCategoryOpen(index: number) {
    if (index !== this.editedRowIndex) {
      if (this.cushioningMaterialForm.valid) {
        this.grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = index;
        this.grid.editRow(index);
      }
    }
  }

  onMaterialChange(material: any, dataItem: any, isFromEvent: boolean) {
    this.materialService.getMaterialDimension(isFromEvent ? material.id : material).subscribe(response => {
      if (response.isSuccess) {
        this.commonService.objectMapping(dataItem, response.data);
        dataItem.nonStdLabor = response.data.laborMinutesPer;
        dataItem.unit = this.units.find(item => item.id == dataItem.unitId).abbreviatedValue;
        dataItem.description = null;
        dataItem.addsToContainer = true;
        dataItem.isChanged = true;
        this.emitReCalculatePackagingQuantity.emit();
      }
    });
  }

  onCushioningDetailsOpenDialog(dataItem: any): void {
    const materialData = this.defaultMaterialsList.find(item => item.id == dataItem.materialId);
    this.dialog.open(CushioningDetailsFormComponent, {
      position: {
        right: '0',
      },
      panelClass: 'small_layout',
      hasBackdrop: false,
      data: {
        cushioningId: null,
        cushioningDetails: dataItem.cushioningDetails,
        packagingName: materialData ? materialData.materialName : '',
        isDisabledForm: this.isDisabledForm || this.readOnly
      },
      autoFocus: false
    }).afterClosed()
      .subscribe((response: any) => {
        if (!response.isClosed) {
          if (response.data) {
            dataItem.cushioningDetails = response.data;
            if (response.isCustomCushioning) {
              dataItem.IsCustomCushioning = response.isCustomCushioning;
            }
            this.cushioningMaterialForm.form.markAsDirty();
            this.emitEnableSaveButton.emit();
          }
        }
      });
  }

  onQuantityChange(dataItem: any) {
    dataItem.isChanged = true;
    this.emitEnableSaveButton.emit();
    this.emitReCalculatePackagingQuantity.emit();
  }

  onDescChange(dataItem: any) {
    dataItem.isChanged = true;
  }

  handleFilter(value: any) {
    this.defaultMaterialsListFiltered = this.defaultMaterialsList.filter((s) => s.materialName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
}
